import React, { useState, useCallback, useRef, memo } from "react";
import { useNavigate } from "react-router-dom";
import { OrangeCap } from "./NormalSearch";

function AISearch() {
  const [text,    setText]    = useState("");
  const [loading, setLoading] = useState(false);
  const [imgErr,  setImgErr]  = useState(false);
  const inputRef  = useRef(null);
  const navigate  = useNavigate();

  const handleSearch = useCallback(() => {
    const query = text.trim();
    if (!query || loading) return;
    setLoading(true);
    setTimeout(() => {
      navigate("/ai-search", { state: { question: query } });
      setText("");
      setLoading(false);
    }, 120);
  }, [text, loading, navigate]);

  const handleClear = useCallback(() => {
    setText("");
    inputRef.current?.focus();
  }, []);

  return (
    <div className="search-pill ai">

      {/* Robot image — sits at left edge of pill */}
      <div className="ai-avatar" aria-hidden="true">
        {!imgErr ? (
          <img src="/images/ai-robot.png" alt="AI agent"
            onError={() => setImgErr(true)} />
        ) : (
          <svg viewBox="0 0 42 42" fill="none" width="42" height="42">
            <circle cx="21" cy="21" r="21" fill="#e8f0fe"/>
            <rect x="11" y="17" width="20" height="14" rx="5" fill="#1a56db"/>
            <line x1="21" y1="17" x2="21" y2="12"
              stroke="#1a56db" strokeWidth="2.5" strokeLinecap="round"/>
            <circle cx="21" cy="10" r="2.5" fill="#1a56db"/>
            <circle cx="16.5" cy="23" r="2" fill="white"/>
            <circle cx="25.5" cy="23" r="2" fill="white"/>
            <rect x="16" y="27" width="10" height="2.5" rx="1.25" fill="white"/>
          </svg>
        )}
      </div>

      {/* White text input */}
      <div className="pill-content">
        <div className="input-wrapper">
          <input
            ref={inputRef}
            className="pill-input"
            placeholder="Explore, discover, analyse with AI"
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            disabled={loading}
            autoComplete="off"
            aria-label="Ask AI property agent"
          />
          {text && !loading && (
            <button className="clear-btn" onClick={handleClear}
              aria-label="Clear" type="button">✕</button>
          )}
        </div>
      </div>

      {/* Orange concave-left cap — wider for 3 icons */}
      <OrangeCap height={58} width={155} className="ai-cap">

        <button className="ai-action-btn" type="button" aria-label="Attach file">
          <svg width="19" height="19" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.2"
            strokeLinecap="round" strokeLinejoin="round">
            <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19
                     a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
          </svg>
        </button>

        <button className="ai-action-btn" type="button" aria-label="Voice input">
          <svg width="19" height="19" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.2"
            strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
            <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
            <line x1="12" y1="19" x2="12" y2="23"/>
            <line x1="8"  y1="23" x2="16" y2="23"/>
          </svg>
        </button>

        <button className="ai-action-btn" type="button" aria-label="Ask AI"
          onClick={handleSearch} disabled={loading}>
          {loading ? (
            <span className="loader-dots">···</span>
          ) : (
            <div className="waveform" aria-hidden="true">
              <span /><span /><span /><span /><span />
            </div>
          )}
        </button>

      </OrangeCap>
    </div>
  );
}

export default memo(AISearch);